import { createSlice } from '@reduxjs/toolkit'
import { get, some, uniqBy } from 'lodash'
import { useSelector } from 'react-redux'

import api from 'common/api'

import { selectOrgId } from '../organization'

const schoolEmailDomains = createSlice({
  name: 'schoolEmailDomains',
  initialState: {
    addresses: [],
    emailDomains: [],
    isFetchingDomains: false,
    hasFetchedDomains: false,
    domainError: false,
    hasSentEmails: false,
  },
  reducers: {
    fetchDomains(state) {
      state.isFetchingDomains = true
    },
    fetchDomainsSuccess(state, action) {
      state.emailDomains = action.payload
      state.domainError = false
      state.isFetchingDomains = false
      state.hasFetchedDomains = true
    },
    fetchAddressesSuccess(state, action) {
      state.addresses = uniqBy(action.payload, 'Address')
    },
    fetchDomainsFailure(state) {
      state.domainError = true
      state.isFetchingDomains = false
    },
    setEmailHistoryFlag(state, action) {
      state.hasSentEmails = get(action, 'payload', false)
    },
  },
})

export const hasFetchedDomains = (state) => state.schoolEmailDomains.hasFetchedDomains
export const selectAddresses = (state) => state.schoolEmailDomains.addresses
export const useAddresses = () => useSelector(selectAddresses)
export const selectEmailDomains = (state) => state.schoolEmailDomains.emailDomains
export const hasEmailHistory = (state) =>
  state.schoolEmailDomains.hasSentEmails || some(state.schoolEmailDomains.emailDomains, { State: 'verified_state' })

export const {
  fetchDomains,
  fetchDomainsSuccess,
  fetchDomainsFailure,
  fetchAddressesSuccess,
  fetchAddressesFailure,
  setEmailHistoryFlag,
} = schoolEmailDomains.actions

const resolveEmailIntegrations = (emailIntegrations, dispatch) => {
  dispatch(fetchDomainsSuccess(get(emailIntegrations, 'Domains', [])))
  dispatch(fetchAddressesSuccess(get(emailIntegrations, 'Addresses', [])))
  dispatch(setEmailHistoryFlag(get(emailIntegrations, 'HasSentEmails')))
  return emailIntegrations
}
const getDomains = (dispatch, getState) => {
  const state = getState()
  dispatch(fetchDomains())
  const orgId = selectOrgId(state)
  return api
    .get(`/api/organizations/${orgId}/email/domain`)
    .then((emailIntegrations) => resolveEmailIntegrations(emailIntegrations, dispatch))
    .catch(() => {
      dispatch(fetchDomainsFailure())
      return Promise.reject()
    })
}
export const deleteDomain = (domainId) => (dispatch, getState) => {
  const state = getState()
  const orgId = selectOrgId(state)
  return api
    .delete(`/api/organizations/${orgId}/email/domain/${domainId}`)
    .then((emailIntegrations) => resolveEmailIntegrations(emailIntegrations, dispatch))
    .catch(() => {
      dispatch(fetchDomainsFailure())
      return Promise.reject()
    })
}
export const addDomain = (Domain, Propagate) => (dispatch, getState) => {
  const state = getState()
  const orgId = selectOrgId(state)
  return api
    .post(`/api/organizations/${orgId}/email/domain`, { Domain, Propagate })
    .then((emailIntegrations) => resolveEmailIntegrations(emailIntegrations, dispatch))
    .catch(() => {
      dispatch(fetchDomainsFailure())
      return Promise.reject()
    })
}
export const initializeDomains = () => (dispatch, getState) => {
  const state = getState()
  const storeSlice = state.schoolEmailDomains
  const { isFetchingDomains, hasFetchedDomains, domainError } = storeSlice
  if (!isFetchingDomains && !hasFetchedDomains && !domainError) {
    getDomains(dispatch, getState).catch(() => {})
  }
}
export const loadDomains = () => (dispatch, getState) => getDomains(dispatch, getState)

export default schoolEmailDomains.reducer
